<script setup>
import {defineProps} from 'vue';

defineProps(['price']);
</script>

<template>
  <div class="advance-payment-price">
    <span>Wysokość zaliczki: {{ price }} zł</span>
  </div>
</template>

<style scoped lang="scss">
.advance-payment-price{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  width: 100%;
}
</style>